module.exports = __webpack_public_path__ + "img/fingerprint.0793c429.svg";